import { asyncStoreItemAdapter } from '@lib/store';
import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './pass-amc-information.actions';
import { PassAmcInformationState } from './pass-amc-information.state';

/**
 * passengerAmcInformation initial state
 */
export const passengerAmcInformationInitialState: PassAmcInformationState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for passengerAmcInformation Store
 */
export const passengerAmcInformationReducerFeatures: ReducerTypes<PassAmcInformationState, ActionCreator[]>[] = [
  on(actions.setPassAmcInformation, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updatePassAmcInformation, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetPassAmcInformation, () => passengerAmcInformationInitialState),

  on(actions.cancelPassAmcInformationRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failPassAmcInformation, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setPassAmcInformationApi, actions.updatePassAmcInformationApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * passengerAmcInformation Store reducer
 */
export const passengerAmcInformationReducer = createReducer(
  passengerAmcInformationInitialState,
  ...passengerAmcInformationReducerFeatures
);
